<template>
	<page-content-layout class="products" title="Enheder">
		<button-view slot="tools" label="Opret" @click="createButtonClick" />
		<new-table-view @itemClick="itemClick" @delete="itemDelete" :columns="[
			{
				label: 'Navn',
				name: 'name'
			},
			{
				label: 'Type',
				name: ['_embedded', 'unit_type', 'name']
			},
			{
				label: 'Rumfang [m3]',
				name: ['_embedded', 'unit_type', 'volume']
			},
			{
				label: 'Længde [cm]',
				name: ['_embedded', 'unit_type', 'length']
			},
			{
				label: 'Bredde [cm]',
				name: ['_embedded', 'unit_type', 'width']
			},
			{
				label: 'Højde [cm]',
				name: ['_embedded', 'unit_type', 'height']
			},
			{
				label: '',
				name: 'delete',
				align: 'right',
				template: {
					name: 'button',
					label: 'Slet'
				}
			}
		]" :items="items" />
	</page-content-layout>
</template>

<script>
	import Unit from '../windows/UnitWindow'
	import NewTableView from '../views/NewTableView'

    export default {
		components: {
			newTableView: NewTableView
		},
		methods: {
			createButtonClick: function () {
				var contacts = this;

				

				this.$store.state.windowStack.push(Unit, {
					onChange: function (ent) {
						
						

						contacts.update();
					}
				});
			},
			itemClick: function (item) {
				

				var contacts = this;

				this.$store.state.windowStack.push(Unit, {id: item.id, form: true, onChange: function () {
					contacts.update();
				}});
			},
			itemDelete(item) {
				if (!confirm('Sikker?')) return;

				var view = this;

				this.axios
					.delete('/warehouse/units/' + item.id + '/')
					.then(function (r) {
						

						if (r.status >= 200 && r.status < 300) {
							view.update();
						}

						
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							alert(r.data);
						} else {
							alert('Server Error');
						}
					});	
			},
			itemAction: function (name, id) {
				if (name == 'delete') {
					if (!confirm('Sure?')) return;

					

					var contacts = this;

					this.axios
						.delete('/warehouse/units/' + id + '/')
						.then(function () {
							contacts.update();
						}, function () {
							alert('Could not delete the item');
						});
				}
			},
			update() {
				var contacts = this;

				this.axios
					.get('/warehouse/units/')
					.then(function (r) {
						contacts.items = r.data._items;
					});
			}
		},
		data: function () {
			return {
				items: [],
				actions: [{name: 'delete', label: 'Delete'}]
			};
		},
		mounted: function () {
			this.axios.put('/activity/units/');
			this.update();


			/*this.axios
				.all([
					this.axios.get('/contacts/'),
					this.axios.get('/contacts/columns/')
				]).then(function (results) {
					
				});*/
		}
    }
</script>

<style lang="scss" scoped>
	.new-table-view {
		width: 100%;
		height: 100%;
	}
</style>